import React from "react";
import { motion } from "framer-motion";
import { cn } from "../lib/utils";

export const GlassPanel = React.forwardRef(({ className = "", interactive = false, children, animate = true, delay = 0, ...rest }, ref) => {
  const base = "glass rounded-3xl p-6";
  const cls = cn(base, interactive && "glass-hover transition-all duration-300 cursor-pointer", className);
  if (!animate) {
    return <div ref={ref} className={cls} {...rest}>{children}</div>;
  }
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
      className={cls}
      {...rest}
    >
      {children}
    </motion.div>
  );
});

GlassPanel.displayName = "GlassPanel";
